export const formatAllergiesToString = (allergies) => {
  if (!allergies || !Array.isArray(allergies) || allergies.length === 0) {
    return "";
  }

  return allergies
    .map((allergy) => {
      const lines = [];

      if (allergy.name) {
        lines.push(`Name: ${allergy.name}`);
      }

      if (allergy.allergyType) {
        lines.push(`Type: ${allergy.allergyType}`);
      }

      if (allergy.allergyReaction && allergy.allergyReaction !== "UNKNOWN") {
        lines.push(`Reaction: ${allergy.allergyReaction}`);
      }

      if (allergy.serious !== null && allergy.serious !== undefined) {
        lines.push(`Serious: ${allergy.serious ? "Yes" : "No"}`);
      }

      if (allergy.drugAllergy && allergy.drugName) {
        lines.push(`Drug: ${allergy.drugName}`);
      }

      if (allergy.drugGenericName) {
        lines.push(`Generic Name: ${allergy.drugGenericName}`);
      }

      return lines.join("\n");
    })
    .join("\n\n");
};

export const formatMedicalHistoryToString = (medicalHistory) => {
  if (
    !medicalHistory ||
    !Array.isArray(medicalHistory) ||
    medicalHistory.length === 0
  ) {
    return "";
  }

  return medicalHistory
    .map((record) => {
      const lines = [];

      if (record.diseaseCode) {
        lines.push(`Disease Code: ${record.diseaseCode}`);
      }

      if (record.medicalDetails) {
        lines.push(`Medical Details: ${record.medicalDetails}`);
      }

      if (record.recordedDate) {
        lines.push(`Recorded Date: ${record.recordedDate}`);
      }

      if (record.diseaseDate) {
        lines.push(`Disease Date: ${record.diseaseDate}`);
      }

      return lines.join("\n");
    })
    .join("\n\n");
};

export const formatFamilyMedicalHistoryToString = (familyMedicalHistory) => {
  if (
    !familyMedicalHistory ||
    !Array.isArray(familyMedicalHistory) ||
    familyMedicalHistory.length === 0
  ) {
    return "";
  }

  return familyMedicalHistory
    .map((record) => {
      const lines = [];

      if (record.familyRelationship) {
        lines.push(`Family Relationship: ${record.familyRelationship}`);
      }

      if (record.diseaseCode) {
        lines.push(`Disease Code: ${record.diseaseCode}`);
      }

      if (record.medicalDetails) {
        lines.push(`Medical Details: ${record.medicalDetails}`);
      }

      if (record.deceased) {
        lines.push(`Deceased: ${record.deceased}`);
      }

      return lines.join("\n");
    })
    .join("\n\n");
};

export { formatLongTermMedicationsToString } from "features/medications/utils/formatLongTermMedications";
